import { SET_DISCARD_PRODUCT_CLICK } from '../../types';

const setDiscardProductClicked = (status, debounceTerm) => (dispatch) => {
  dispatch({ type: SET_DISCARD_PRODUCT_CLICK, status, debounceTerm });
};

export { setDiscardProductClicked };
